import {useEffect,useRef,useId,type ReactNode} from 'react';
import {createPortal} from 'react-dom';
import {I,IconBtn} from '../../ui';
export function ProspectDialog({open,onClose,title,sub,actions,children}:{open:boolean;onClose:()=>void;title:ReactNode;sub:ReactNode;actions?:ReactNode;children:ReactNode}) {
 const ref=useRef<HTMLDialogElement>(null);const id=useId();
 useEffect(()=>{
  const dialog=ref.current;if(!dialog)return;
  if(!open){dialog.close();return;}
  const previous=document.activeElement instanceof HTMLElement?document.activeElement:null;
  const overflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();
  return()=>{dialog.close();document.body.style.overflow=overflow;previous?.focus();};
 },[open]);
 return createPortal(<dialog ref={ref} className="prospect-dialog" aria-labelledby={id} onCancel={e=>{e.preventDefault();onClose();}}>
  <header className="prospect-dialog-head"><div><div className="prospect-eyebrow">Scheda persona · patrimonio documentato</div><h2 id={id}>{title}</h2><p>{sub}</p></div><div className="prospect-dialog-actions">{actions}<IconBtn icon={I.x} title="Chiudi scheda" onClick={onClose}/></div></header>
  <div className="prospect-dialog-body">{open&&children}</div>
 </dialog>,document.body);
}
